<template>
  <div>
    <b-row class="justify-content-start">
      <b-col md="2" class="w-100" v-if="type === 'BULK'">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-col>
    </b-row>
    <b-row class="mt-2 mb-5 justify-content-start">
      <!-- Left section filtre -->
      <b-col cols="4" lg="2" xl="2">
        <b-button class="btnFilter"
          @click="displayFilter = !displayFilter">
          <i v-if="displayFilter" class="fa-light fa-minus"></i>
          <i v-else class="fa-light fa-plus"></i>
          {{ $t('filter.fltr') }}
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="2">
        <b-button class="btnFilter"
          @click="refreshInbox()">
          <i class="fa-light fa-rotate-right"></i>
          {{ $t('common.rfrsh') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row class="min-w-100 justify-content-start" v-if="displayFilter">

      <!--Filtre File Name -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action pb-5">
        <label class="filter-item-title" for="annuaire-filename">{{ $t('annuaire.file_name') }}</label>
        <span class="filter-item-content">
          <input v-model="Name" id="annuaire-filename"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
            :placeholder="$t('annuaire.file_name')"
            style="width: 100%">
        </span>
      </b-col>

      <!--Filtre BIC -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action pb-5">
        <label class="filter-item-title" for="annuaire-bic">{{ $t('annuaire.bic') }}</label>
        <span class="filter-item-content">
          <input v-model="BIC" id="annuaire-bic"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': BIC}"
            :placeholder="$t('annuaire.bic')"
            style="width: 100%">
        </span>
      </b-col>

      <!--Filtre IBAN -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action pb-5">
        <label class="filter-item-title" for="annuaire-iban">{{ $t('annuaire.iban') }}</label>
        <span class="filter-item-content">
          <input v-model="IBAN" id="annuaire-iban"
            type="text"
            :class="{'filter-item-input': true, 'filter-item-input-complete': IBAN}"
            :placeholder="$t('annuaire.iban')"
            style="width: 100%">
        </span>
      </b-col>


      <!-- Filtre date de début -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action pb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}"
          :inputLabel="$t('common.date_start_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateBegin">
        </datetime-picker-custom>
      </b-col>

      <!-- Filtre date de fin -->
      <b-col sm="6" lg="3" cols="12" class="filter-item-action pb-5">
        <datetime-picker-custom class="z-1" format="DD/MM/YYYY H:i:s"
          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}"
          :inputLabel="$t('common.date_end_label')"
          customInputParentClass="filter-item-content"
          customInputClass="w-100"
          :maxLength="19"
          :placeholderValue="$t('common.datetime_picker_empty_date')"
          inputIcon="fa-solid fa-calendar"
          v-model="dateEnd">
        </datetime-picker-custom>
      </b-col>

      <!-- Bouton Effacer et Appliquer -->
      <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-4 pr-0 pb-5">
        <b-button size="sm"
          @click="applyFilter()">
          {{ $t('common.srch') }}
        </b-button>
        <b-button class="mr-3" size="sm"
          @click="clearFilterFields"
          :disabled="!hasInputFilter">
          {{ $t('filter.clr_fltr_field') }}
        </b-button>
      </b-col>
    </b-row>
<!--    <div class="d-flex justify-content-end" v-if="TracksList.length > 0">-->
<!--      <b-button class="btnFilter_2 mx-3"-->
<!--        @click="extractCSV()">-->
<!--        <i class="fa-light fa-upload fs-14px"></i>-->
<!--        <span class="fab-label">{{ $t('common.extract_list') }}</span>-->
<!--      </b-button>-->
<!--    </div>-->
    <spinner v-if="activateSpinner"></spinner>
    <div v-else-if="TracksList.length > 0"  style="overflow:auto">
      <b-table :hover="false"
               class="table table-striped mb-0"
               :fields="fields"
               :items="TracksList"
               :selectable="false"
               :empty-text="$t('common.security.no_result')">
        <template #cell(DateImport)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>
        <template #cell(DateLastUpdate)="data">
          <span>{{ getDate(data.value) }}</span>
        </template>

        <template #cell(Active)="data">
          <span>{{ $t('annuaire.active_'+data.value)}}</span>
        </template>
        <template #cell(Data)="data">
          <div class="d-flex">

            <div class="" v-if="data.item.FirstName1 !== '' || data.item.LastName1 !== '' || data.item.MarriedName1 !== '' || data.item.BirthName1 !== ''">
              <span>{{ $t('annuaire.label_pp_1')}}</span>
              <table class="annuaireTable">
                <tbody>
                <tr>
                  <th class="p-1">{{ $t('annuaire.first_name') }}:</th>
                  <td class="p-1" :title="data.item.FirstName1">{{ data.item.FirstName1 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.last_name') }}:</th>
                  <td class="p-1" :title="data.item.LastName1">{{ data.item.LastName1 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.birth_name') }}:</th>
                  <td class="p-1" :title="data.item.BirthName1">{{ data.item.BirthName1 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.married_name') }}:</th>
                  <td class="p-1" :title="data.item.MarriedName1">{{ data.item.MarriedName1 }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="ml-4" v-if="data.item.FirstName2 !== '' || data.item.LastName2 !== '' || data.item.MarriedName2 !== '' || data.item.BirthName2 !== ''">
              <span>{{ $t('annuaire.label_pp_2')}}</span>
              <table class="annuaireTable">
                <tbody>
                <tr>
                  <th class="p-1">{{ $t('annuaire.first_name') }}:</th>
                  <td class="p-1" :title="data.item.FirstName2">{{ data.item.FirstName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.last_name') }}:</th>
                  <td class="p-1" :title="data.item.LastName2">{{ data.item.LastName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.birth_name') }}:</th>
                  <td class="p-1" :title="data.item.BirthName2">{{ data.item.BirthName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.married_name') }}:</th>
                  <td class="p-1" :title="data.item.MarriedName2">{{ data.item.MarriedName2 }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="" v-if="data.item.CompanyName !== '' || data.item.Siren !== '' || data.item.Siret !== '' || data.item.TVAIntracomm !== ''">
              <span>{{ $t('annuaire.label_pm_1')}}:</span>
              <table class="annuaireTable" >
                <tbody>
                <tr>
                  <th class="p-1">{{ $t('annuaire.company_name') }}:</th>
                  <td class="p-1" :title="data.item.MarriedName2">{{ data.item.CompanyName }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.trading_name') }}:</th>
                  <td class="p-1" :title="data.item.TradingName">{{ data.item.TradingName }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.siren') }}:</th>
                  <td class="p-1" :title="data.item.Siren">{{ data.item.Siren }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.siret') }}:</th>
                  <td class="p-1" :title="data.item.Siret">{{ data.item.Siret }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.tva_intracomm') }}:</th>
                  <td class="p-1" :title="data.item.TVAIntracomm">{{ data.item.TVAIntracomm }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.lei') }}:</th>
                  <td class="p-1" :title="data.item.LEI">{{ data.item.LEI }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.euid') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.EUID }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="ml-4" v-if="data.item.CompanyName2 !== '' || data.item.Siren2 !== '' || data.item.Siret2 !== '' || data.item.TVAIntracomm2 !== ''">
              <span>{{ $t('annuaire.label_pm_2')}}:</span>
              <table class="annuaireTable" >
                <tbody>
                <tr>
                  <th class="p-1">{{ $t('annuaire.company_name') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.CompanyName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.trading_name') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.TradingName2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.siren') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.Siren2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.siret') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.Siret2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.tva_intracomm') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.TVAIntracomm2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.lei') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.LEI2 }}</td>
                </tr>
                <tr>
                  <th class="p-1">{{ $t('annuaire.euid') }}:</th>
                  <td class="p-1" :title="data.item.EUID">{{ data.item.EUID2 }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div v-else class="d-flex justify-content-center">
      <span class="noResult">
        {{ $t('common.no_result') }}
      </span>
    </div>
    <b-row class="mt-5">
      <b-col cols="12">
        <cm-pagination
          :maxResultsByPage="paginationObject.maxResults"
          :firstIndex="paginationObject.firstIndex"
          :nbResultsTotal="paginationObject.nbResultsTotal"
          :refreshEvent="paginationObject.refresh">
        </cm-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import {downloadFileWithDefinedHeaders} from "@/helpers/download";
import BackButton from "@/components/common/backButton.vue";


export default {
  name: 'AnnuaireLineList',
  components: {
    BackButton,
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      fields = [
        { key: 'BIC', label: this.$i18n.t('annuaire.bic'), class: 'text-center', sortable: false },
        { key: 'IBAN', label: this.$i18n.t('annuaire.iban'), class: 'text-center', sortable: false },
        { key: 'Data', label: this.$i18n.t('annuaire.data'), class: 'text-center', sortable: false },
        { key: 'DateImport', label: this.$i18n.t('annuaire.date_import'), class: 'text-center', sortable: false },
        { key: 'DateLastUpdate', label: this.$i18n.t('annuaire.date_last_update'), class: 'text-center', sortable: false },
        { key: 'FileName', label: this.$i18n.t('annuaire.file_name'), class: 'text-center', sortable: false },
        { key: 'Active', label: this.$i18n.t('annuaire.active'), class: 'text-center', sortable: false },
      ]

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.Name ||
          this.IBAN ||
          this.BIC ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterBy: '',
      hasDefaultFilter: false,
      idTrackAcc: '',
      statusVerification: '',
      mode: 1,
      identifier: '',
      technicalStatus: '',
      BIC: '',
      Name: '',
      IBAN: '',
      dateBegin: '',
      returnUrl: '',
      dateEnd: '',
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      trackActive: '',
      TracksList: []
    }
  },
  created () {
    if (this.type === 'BULK') {
      this.defineReturnURL()
    }
    // this.$bus.$emit('switch-selected-menu', '/annuaire/')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Tracking',
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.annuaire.cleanFilterCondition()
  },
  methods: {
    defineReturnURL () {
      let that = this
      this.returnUrl =  '/annuaire/file/' + this.id
    },
    applyFilter (filterConditions = {}) {
      this.TracksList = []
      let that = this
      this.filterTypeGet = 'list'
      this.$engine.annuaire.cleanFilterCondition()

      if (this.id !== 'NULL') {
        filterConditions.IdAnnuaire = this.id
      }
      filterConditions.maxResults = this.paginationObject.maxResults
      filterConditions.firstIndex = this.paginationObject.firstIndex
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name.trim()
      filterConditions.IBAN = this.IBAN.trim()
      filterConditions.BIC = this.BIC.trim()
      filterConditions.ByClient = 1

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0
      this.activateSpinner = true
      this.$engine.annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
        that.paginationObject.nbResults = resp.data.annuaires.length
        resp.data.annuaires.forEach(item => {
          item.company_name = item.company_name
          item.statusVerification = item.statusVerification
          item.active = item.active
        })
        requests = resp.data.annuaires
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.Name = ''
      this.IBAN = ''
      this.BIC = ''
      this.dateEnd = ''
      this.dateBegin = ''
      this.communicateChange()
      // this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        ByClient: 1,
      }
      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name.trim()
      filterConditions.IBAN = this.IBAN.trim()
      filterConditions.BIC = this.BIC.trim()

      if (this.id !== 'NULL') {
        filterConditions.IdAnnuaire = this.id
      }
      this.$engine.annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        this.TracksList = []
        let requests = {}
        if (resp.data && resp.data.annuaires.length > 0) {
          that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
          that.paginationObject.nbResults = resp.data.annuaires.length
          requests = resp.data.annuaires
          that.updateInbox(requests, noAttach)
          that.$f7.pullToRefreshDone()
          that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        }
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    extractCSV (){
      let that = this
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let filterConditions = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        extract : 1,
      }

      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name

      if (this.id !== 'NULL') {
        filterConditions.IdAnnuaire = this.id
      }
      this.$engine.annuaire.getAnnuaires(
        filterConditions
      ).then(resp => {
        that.$f7.hidePreloader()
        const linkSource = 'data:text/csv;charset:utf-8;base64,' + resp.data
        const downloadLink = document.createElement('a')
        let today = moment()
        const fileName = that.$t('Webheader.annuaire') + '_' + today.unix() + '.csv'
        if (
          this.$f7.device.os === 'android' ||
          this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDetail (id) {
      let that = this
      if (this.type === 'BULK') {
        type = this.id
      }
      loadPage(that, {url: '/annuairedetails/' + type +'/' + id})
    },
    reOrderBy (column) {
      this.TracksList = []
      let that = this
      if (this.sortField === column) {
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions


      filterConditions.dateBegin = this.dateBegin != '' ? moment(this.dateBegin, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.dateEnd = this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss').utc().format('YYYY-MM-DDTHH:mm:ss') : ''
      filterConditions.Name = this.Name.trim()
      filterConditions.IBAN = this.IBAN.trim()
      filterConditions.BIC = this.BIC.trim()
      filterConditions.ByClient = 1

      if (this.id !== 'NULL'){
        filterConditions.IdAnnuaire = this.id
      }
      this.$engine.annuaire.getAnnuaires(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.countAnnuaires
        that.paginationObject.nbResults = resp.data.annuaires.length
        resp.data.annuaires.forEach(item => {
          item.statusVerification = item.statusVerification
          item.company_name = item.company_name
          item.active = item.active
        })
        requests = resp.data.annuaires
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.TracksList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    seeTracksDetails (items) {
      this.activateDetail(items[0].IdTrack)
    },
    getDate (date) {
      if (date !== '') {
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm')
      }
      else {
        return '-'
      }
    },
    showButtonImportLot () {
      return false
    }
  }
}
</script>
